import { CardContent } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { Datagrid, EditButton, FunctionField, ReferenceField, TextField, useNotify, useRefresh } from "react-admin";
import FilterToolbar from "../../../Components/FiltersToolbar/FilterToolbar";
import CreatedByField from "../../../Components/ReferenceFields/CreatedBy/CreatedByField";
import { DefaultPerPageSize } from "../../../Constants/Constant";
import { SourceVwUser } from "../../../Constants/Source";
import {
  AircraftUnderMaintenanceStatus,
  AircraftUnderMaintenanceType,
} from "../../../Enums/AircraftUnderMaintenanceEnums";
import { FilterInputType, FilterTypes } from "../../../Enums/FilterTypes";
import { ExcelExport } from "../../../Helper/ExportExcel";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { useAppDataProvider } from "../../../dataprovider";
import { TitlesAUM, sourceAUM } from "../Constants/Constants";
import LoadingPopup from "./Loading";
import ListActions from "./ListActions";
import AcceptIconButton from "../../../Components/AcceptButton/AcceptIconButton";
import RejectIconButton from "../../../Components/RejectButton/RejectIconButton";
import { useAuth } from "@airborne/react-admin";
import { CustomDateField } from "../../../Components/CustomDateField";
import PoolList from "../../../Components/PoolListComponent/PoolListComponent";

const SearchAUM = props => {
  const [loading, setLoading] = useState(false);
  const [maintenanceType, setMaintenanceType] = useState<any>();
  const [customers, setCustomers] = useState<any>();
  const [acRegList, setAcRegList] = React.useState<any>([]);
  const notify = useNotify();
  const refresh = useRefresh();
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();

  useEffect(() => {
    GetCustomers();
    GetMaintenanceType();
  }, []);
  const GetCustomers = () => {
    dataProvider
      .getList(SourceCustomer, {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerCode", order: "ASC" },
        filter: {},
      })
      .then(response => {
        setCustomers(response.data);
      });
  };
  const GetAcRegList = e => {
    const customerId = e?.target?.value;
    if (!(customerId > 0)) {
      return;
    }
    var customerOwnerCode = customers.find(x => x.id == customerId)?.ownerCode;
    if (!customerOwnerCode) {
      setAcRegList([]);
      return;
    }
    dataProvider
      .getAircraftListByOwnerCode(customerOwnerCode)
      .then(response => {
        let data: any = response?.data?.items;
        if (data.length > 0) {
          setAcRegList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  const GetMaintenanceType = () => {
    dataProvider
      .getList("ParameterDefinitions", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "id", order: "ASC" },
        filter: { parameterGroupCode__eq: AircraftUnderMaintenanceType.GroupName },
      })
      .then(response => {
        setMaintenanceType(response.data);
      });
  };
  const ExportToExcel = (records, fetchRelatedRecords) => {
    fetchRelatedRecords(records, "createdBy", SourceVwUser).then(createdBy => {
      fetchRelatedRecords(records, "updatedBy", SourceVwUser).then(updatedBy => {
        fetchRelatedRecords(records, "acId", "cdmaircraft").then(aircraft => {
          const data = records.map(record => ({
            "Maintenance Type":
              maintenanceType.find(x => x.parameterValue == record.maintenanceType)?.parameterDesc ?? "",
            "Scheduled Start Date": record.scheduledStartDate,
            "Scheduled Finish Date": record.scheduledFinishDate,
            "Real Start Date": record.realStartDate,
            "Real Finish Date": record.realFinishDate,
            Customer: customers.find(x => x.id == record.customerId)?.customerName ?? "",
            AC: aircraft[record.acId]?.acReg,
            Remark: record.Remark,
            "Created By": `${createdBy[record.createdBy]?.registerId} - ${createdBy[record.createdBy]?.name}`,
            "Created Date": record.createdDate,
            "Updated By": `${updatedBy[record.updatedBy]?.registerId ?? ""} - ${updatedBy[record.updatedBy]?.name ?? ""}`,
            "Updated Date": record.updatedDate ? record.updatedDate : "",
          }));

          const columns = Object.keys(data[0]).map(record => ({ header: record }));
          ExcelExport(columns, data, "Aircraft Under Maintenance Report");
        });
      });
    });
  };
  const UpdateStatus = status => record => {
    dataProvider
      .putAircraftUnderMaintenances({ ...record, ...{ status: status } })
      .then(response => {
        notify(`Record updated`, "success", false, false);
        refresh();
      })
      .catch(response => {
        notify(`${response?.response?.data?.message ?? response}`, "error", false, false);
      });
  };
  return (
    <>
      <Fragment>
        <CardContent>
          <PoolList
            {...props}
            bulkActionButtons={false}
            title={TitlesAUM.list}
            exporter={ExportToExcel}
            actions={<ListActions customers={customers} notify={notify} />}
            perPage={DefaultPerPageSize}
            resource={sourceAUM}
            filters={
              <FilterToolbar
                dataSource={[
                  {
                    style: { minWidth: "250px" },
                    source: "maintenanceType",
                    inputType: FilterInputType.Select,
                    label: "Maintenance Type",
                    filterTypeChangeDisable: true,
                    filterType: FilterTypes.Equals,
                    choices: maintenanceType,
                    optionValue: "parameterValue",
                    optionText: "parameterDesc",
                  },
                  {
                    style: { minWidth: "250px" },
                    source: "scheduledStartDate",
                    inputType: FilterInputType.Date,
                    label: "Scheduled Start Date",
                    filterType: FilterTypes.GreaterThan,
                  },
                  {
                    style: { minWidth: "250px" },
                    source: "scheduledFinishDate",
                    inputType: FilterInputType.Date,
                    label: "Scheduled Finish Date",
                    filterType: FilterTypes.LessThan,
                  },
                  {
                    style: { minWidth: "250px" },
                    source: "realStartDate",
                    inputType: FilterInputType.Date,
                    label: "Real Start Date",
                    filterType: FilterTypes.GreaterThan,
                  },
                  {
                    style: { minWidth: "250px" },
                    source: "realFinishDate",
                    inputType: FilterInputType.Date,
                    label: "Real Finish Date",
                    filterType: FilterTypes.LessThan,
                  },
                  {
                    style: { minWidth: "250px" },
                    source: "customerId",
                    inputType: FilterInputType.Select,
                    label: "Customer",
                    filterTypeChangeDisable: true,
                    filterType: FilterTypes.Equals,
                    choices: customers,
                    optionValue: "id",
                    optionText: "customerName",
                    onChange: GetAcRegList,
                  },
                  {
                    style: { minWidth: "250px" },
                    source: "acId",
                    inputType: FilterInputType.Select,
                    label: "AC",
                    filterTypeChangeDisable: true,
                    filterType: FilterTypes.Equals,
                    choices: acRegList,
                    optionValue: "id",
                    optionText: "acReg",
                  },
                ]}
              />
            }
          >
            <Datagrid>
              <FunctionField
                style={{ fontSize: 12 }}
                label="Maintenance Type"
                render={(record: any) =>
                  maintenanceType?.find?.(x => x.parameterValue == record.maintenanceType)?.parameterDesc ?? ""
                }
              />
              <CustomDateField source="scheduledStartDate" showTime />
              <CustomDateField source="scheduledFinishDate" showTime />
              <CustomDateField source="realStartDate" showTime />
              <CustomDateField source="realFinishDate" showTime />
              <ReferenceField label="Customer" source="customerId" reference={SourceCustomer} link={false}>
                <TextField source="customerName" />
              </ReferenceField>
              <ReferenceField label="AC" source="acId" reference={"cdmaircraft"} link={false}>
                <TextField source="acReg" />
              </ReferenceField>
              <TextField source="remark" />
              <CreatedByField source="createdBy" link={false} />
              <CustomDateField source="createdDate" showTime />
              <CreatedByField source="updatedBy" link={false} />
              <CustomDateField source="updatedDate" showTime />
              <FunctionField
                style={{ fontSize: 12 }}
                label="Actions"
                render={(record: any) => {
                  return (
                    <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "center", gap: "10%" }}>
                      <EditButton record={record} />
                      {record.status !== AircraftUnderMaintenanceStatus.Open ? (
                        record.status == AircraftUnderMaintenanceStatus.Cancelled ? (
                          <div style={{ fontWeight: 600, fontSize: 14, color: "#c90c0f" }}>Cancelled</div>
                        ) : (
                          <div style={{ fontWeight: 600, fontSize: 14, color: "#12824c" }}>Accepted</div>
                        )
                      ) : (
                        <>
                          <RejectIconButton
                            record={record}
                            onClick={UpdateStatus(AircraftUnderMaintenanceStatus.Cancelled)}
                          />
                          {!user?.isCustomer && (
                            <AcceptIconButton
                              record={record}
                              onClick={UpdateStatus(AircraftUnderMaintenanceStatus.Accepted)}
                            />
                          )}
                        </>
                      )}
                    </div>
                  );
                }}
              />
            </Datagrid>
          </PoolList>
        </CardContent>
      </Fragment>
      {loading && <LoadingPopup loading={loading} />}
    </>
  );
};

export default SearchAUM;
